<template>
  <div>
    <p class="headerstyle">แก้ไขคอร์สเรียน</p>
    <div id="fadeIn" v-if="errors.length" class="error-style">
      <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="fromstyle">
      <form @submit.prevent="checkForm($event)">
        <br />
        <button
          class="uploadfield"
          @dragover.prevent
          @drop.prevent
          @click="onPickCourseImg"
          type="button"
        >
          <div
            @drop="dragCourseImg"
            class="flex items-center justify-center  h-full"
          >
            <img
              v-if="CourseImg"
              class="h-full w-full object-scale-down"
              :src="CourseImg.url"
            />
            <img
              v-show="!CourseImg"
              class="object-contain"
              src="@/assets/images/elements/uploadbanner.svg"
            />
          </div>
        </button>
        <input
          type="file"
          accept="image/*"
          style="display: none"
          ref="CourseImgInput"
          @change="uploadCourseImg($event)"
        />
        <br />
        <div class="flex justify-center">
          <div class="w-3/5">
            <div class="flex mb-5">
              <vs-input
                class="w-full pr-4"
                placeholder="ชื่อไฟล์ประกอบการเรียน"
                v-model="Documentfile.name"
                disabled
              />
              <br />
              <button type="button" class="upload-btn" @click="onPickFile">
                <img
                  class="upload-btn-img"
                  src="@/assets/images/elements/upload-btn.svg"
                />
              </button>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                @change="uploadDocument($event)"
              />
            </div>
            <vs-row>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="8">
                <vs-input
                  class="w-full mb-5"
                  id="header"
                  placeholder="รหัสคอร์สเรียน"
                  v-model="course_code"
                  v-debounce:500ms="CheckCourseCode"
                  required
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="4" class="pl-4"> </vs-col>
            </vs-row>
            <vs-input
              class="w-full mb-5"
              placeholder="ชื่อคอร์ส"
              v-model="course_name"
              v-debounce:500ms="CheckCourseName"
              required
            />
            <select
              class="mb-5 custom-select"
              name="level"
              v-model="level"
              required
            >
              <option value="null" disabled>ระดับความเหมาะสมของผู้เรียน</option>
              <option value="Basic">Basic</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advance">Advance</option>
            </select>
            <multiselect
              class="cus-select"
              v-model="value"
              :options="options"
              placeholder="ผู้สอน"
              label="name"
              track-by="name"
              :allow-empty="false"
            >
            </multiselect>
            <vs-textarea
              label="รายละเอียดหลักสูตรโดยย่อ"
              height="200px"
              v-model="subcourse_name"
              required
            />
            <vs-textarea
              label="รายละเอียดคอร์สเรียน"
              height="200px"
              v-model="description"
              required
            />
            <p class="m-0">อัพโหลดคลิปตัวอย่างคอร์สเรียน</p>
            <div class="flex">
              <vs-input
                class="w-full pr-4"
                placeholder="ไฟล์คลิปตัวอย่างคอร์สเรียน"
                v-model="videoinfo"
                disabled
              />
              <button type="button" class="upload-btn" @click="onPickVideo">
                <img
                  class="upload-btn-img"
                  src="@/assets/images/elements/upload-btn.svg"
                />
              </button>
              <input
                type="file"
                accept="video/*"
                style="display: none"
                ref="videoInput"
                @change="selectVideo($event)"
              />
            </div>
            <b-progress
              v-show="vidPercent !== 0"
              class="mt-2"
              max="100"
              show-value
            >
              <b-progress-bar
                :value="vidPercent"
                variant="success"
              ></b-progress-bar>
            </b-progress>
            <br />
            <p class="m-0">ราคา และรูปแบบค่าใช้จ่ายของคอร์สเรียน</p>
            <div class="my-4">
              <vs-radio
                class="mr-4"
                color="#0430ad"
                v-model="priceType"
                vs-name="priceType"
                vs-value="paid"
                >&nbsp;มีค่าใช้จ่าย</vs-radio
              >
              <vs-radio
                color="#0430ad"
                vs-name="priceType"
                v-model="priceType"
                vs-value="free"
                >&nbsp;ฟรี</vs-radio
              >
            </div>
            <vs-row v-if="priceType === 'paid'">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="8">
                <vs-input
                  class="w-full"
                  id="header"
                  placeholder="ราคาคอร์สเรียน"
                  v-model="course_price"
                  type="number"
                  required
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="4" class="pl-4">
                <select
                  class="h-full custom-select"
                  name="paymenttype"
                  v-model="paymenttype"
                  required
                >
                  <option value="null" disabled>รายเดือน / ถาวร</option>
                  <option value="30">รายเดือน</option>
                  <option value="0">ถาวร</option>
                </select>
              </vs-col>
            </vs-row>
            <br />

            <div class="flex justify-center">
              <button
                class="share-btn pointer"
                value="Submit"
                type="submit"
                :disabled="isDisable"
              >
                แก้ไขคอร์สเรียน
              </button>
            </div>
          </div>
        </div>
        <p class="footer-text">
          คอร์สเรียนเมื่อถูกเพิ่มแล้ว จะอยู่ในสถานะ “ยังไม่เผยแพร่” <br />
          โดยสามารถปรับเป็น “เผยแพร่” ได้ในภายหลัง
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import normAxios from "axios";
import Multiselect from "vue-multiselect";
import * as tus from "tus-js-client";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    ShowVideofile(e) {
      this.vidPercent !== "0.00%"
        ? (this.videoinfo = `${e.name} `)
        : (this.videoinfo = e.name);
    },
    checkForm(e) {
      this.isDisable = true;
      this.errors = [];
      if (!this.value) {
        this.errors.push("กรุณาเลือกผู้สอน");
      }
      if (!this.CourseImg) {
        this.errors.push("กรุณาอัพโหลดภาพปก");
      }
      if (!this.Documentfile) {
        this.errors.push("กรุณาเพิ่มไฟล์ประกอบการเรียน");
      }
      if (!this.level) {
        this.errors.push("กรุณาเลือกระดับความเหมาะสมของผู้เรียน");
      }
      if (!this.Documentfile) {
        this.errors.push("กรุณาอัพโหลดไฟล์ประกอบการเรียน");
      }

      if (!this.videoinfo) {
        this.errors.push("กรุณาอัพโหลดคลิปตัวอย่างคอร์สเรียน");
      }

      if (this.priceType === "paid" && this.course_price <= 0) {
        this.errors.push("กรุณากรอกราคาคอร์สให้ถูกต้อง");
      }

      if (this.errors.length) {
        this.isDisable = false;
        for (const error of this.errors) {
          this.$vs.notify({
            title: "Error message",
            text: error,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        }
        return;
      }

      if (this.videofile && this.videoinfo !== this.data.intro_video) {
        console.log("check", this.videofile, this.videoinfo);
        this.isDisable = true;
        this.uploadLarge(this.videofile);
      } else {
        this.$vs.loading();
        let config = {
          url: `${baseUrl.baseurl()}/editCourse`,
          method: "put",
          data: {
            course_code: this.course_code.trimLeft(),
            title: this.course_name.trimLeft(),
            sub_title: this.subcourse_name.trimLeft(),
            cover_img: this.CourseImg.url,
            intro_video: this.data.intro_video,
            file: this.Documentfile.url,
            description: this.description,
            lecturer: {
              new_lecturer: this.value.code,
              old_lecturer: this.data.lecturer.lecturer_id
            },
            course_id: this.$route.params.id,
            level: this.level,
            course_price: {
              course_price_id: this.data.course_prices.course_price_id,
              course_price:
                this.priceType === "paid" ? parseInt(this.course_price) : 0,
              day_until_expire: this.priceType === "paid" ? this.paymenttype : 0
            }
          }
        };
        axios
          .api(config)
          .then(res => {
            this.$vs.loading.close();
            this.$router.push(
              `/curriculum/${this.data.curriculum_id.curriculum_id}`
            );
            this.$vs.notify({
              title: "แก้ไขคอร์สเรียน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
          })
          .catch(error => {
            this.$vs.notify({
              title: "Error message",
              text: `${
                error.response.data.error ? error.response.data.error : error
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
            this.isDisable = false;
            this.$vs.loading.close();
          });
      }
    },
    /////// File Video ////////
    onPickVideo() {
      this.$refs.videoInput.click();
    },
    selectVideo(e) {
      this.ShowVideofile(e.target.files[0]);
      this.videofile = e.target.files[0];
    },
    ///////File course////////
    onPickFile() {
      this.$refs.fileInput.click();
    },

    async uploadDocument(e) {
      console.log("file", e.target.files[0]);
      this.Documentfile = await this.uploadFile(e.target.files[0]);
    },

    //////Course Image///////
    onPickCourseImg() {
      this.$refs.CourseImgInput.click();
    },
    async dragCourseImg(e) {
      console.log("file drag", e.dataTransfer.files[0]);
      this.CourseImg = await this.uploadFile(e.dataTransfer.files[0]);
    },
    async uploadCourseImg(e) {
      console.log("file click", e.target.files[0]);
      this.CourseImg = await this.uploadFile(e.target.files[0]);
    },

    async uploadFile(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("folder_id", 1);
      try {
        let res = await normAxios.post(
          "https://api.fastation.co.th/file/api/file/create",
          fd
        );
        console.log(res.data);
        if (res.status == 200) {
          return res.data.data.uploadFileAtLevel;
        } else {
          alert(res.data.message);
        }
      } catch (error) {
        alert(error.response.data.message.toString());
      }
    },

    async uploadLarge(e) {
      console.log("File", this.videofile);
      var file = this.videofile;
      let fileName = file.name;
      let fileType = file.type;
      let fileSize = file.size;
      let url = "";

      const UpdateVidPercent = text => {
        console.log(this.vidPercent);
        this.vidPercent = text;
        this.ShowVideofile(this.videofile);
      };
      const editCourse = async () => {
        let config = {
          url: `${baseUrl.baseurl()}/editCourse`,
          method: "put",
          data: {
            course_code: this.course_code.trimLeft(),
            title: this.course_name.trimLeft(),
            sub_title: this.subcourse_name.trimLeft(),
            cover_img: this.CourseImg.url,
            intro_video: url,
            file: this.Documentfile.url ? this.Documentfile.url : "",
            description: this.description,
            lecturer: {
              new_lecturer: this.value.code,
              old_lecturer: this.data.lecturer.lecturer_id
            },
            course_id: this.$route.params.id,
            is_public: false,
            level: this.level,
            course_price: {
              course_price_id: this.data.course_prices.course_price_id,
              course_price: parseInt(this.course_price),
              day_until_expire: this.paymenttype
            }
          }
        };
        await axios
          .api(config)
          .then(res => {
            this.isDisable = false;
            this.$vs.notify({
              title: "การแก้ไขคอร์สเรียน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push(
              `/curriculum/${this.data.curriculum_id.curriculum_id}`
            );
          })
          .catch(err => {
            this.$vs.notify({
              title: "Error message",
              text: `${
                err.response.data.error ? err.response.data.error : err
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
            this.isDisable = false;
          });
      };

      // Create a new tus upload
      var upload = new tus.Upload(file, {
        endpoint: `${baseUrl.baseurl()}/uploadVideo`,
        removeFingerprintOnSuccess: true,
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem('token')}`,
        // },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000],
        metadata: {
          name: fileName,
          filename: fileName,
          filetype: fileType
          // requiresignedurls: true,
          // watermark: "deaa1dec879f99462b5c434613c8b1cd",
        },
        uploadSize: fileSize,
        onError: function(error) {
          console.log("Failed because: " + error);
        },
        onProgress: function(bytesUploaded, bytesTotal) {
          var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
          console.log(bytesUploaded, bytesTotal, percentage + "%");
          UpdateVidPercent(percentage);
        },
        onSuccess: function() {
          // console.log("Download %s from %s", upload.file.name, upload.url);
          editCourse();
        },
        onAfterResponse: function(req, res) {
          return new Promise(resolve => {
            var mediaIdHeader = res.getHeader("stream-media-id");
            if (mediaIdHeader) {
              url = mediaIdHeader;
              console.log("mediaIdHeader: ", mediaIdHeader);
            }
            resolve();
          });
        }
      });

      try {
        let checkcourse = await axios.api.post(
          `${baseUrl.baseurl()}/checkCourseUpdateExist`,
          {
            course_id: this.data.course_id,
            title: this.course_name.trimLeft()
          }
        );
        if (checkcourse.status == 400) {
          this.errors.push(err.response.data.error);
          this.isDisable = true;
          return;
        }
        let checkcourse_code = await axios.api.post(
          `${baseUrl.baseurl()}/checkCourseUpdateExist`,
          {
            course_id: this.data.course_id,
            course_code: this.course_code.trimLeft()
          }
        );
        if (checkcourse_code.status == 400) {
          this.errors.push(err.response.data.error);
          this.isDisable = true;
          return;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error message",
          text: `${
            error.response.data.error ? error.response.data.error : error
          }`,
          color: "danger",
          icon: "error",
          position: "top-right"
        });
        this.isDisable = false;
      }

      // Check if there are any previous uploads to continue.
      upload.findPreviousUploads().then(function(previousUploads) {
        // Found previous uploads so we select the first one.
        if (previousUploads.length) {
          upload.resumeFromPreviousUpload(previousUploads[0]);
        }
        // Start the upload
        upload.start();
      });
    },

    Syncdata() {
      this.course_code = this.data.course_code;
      this.course_name = this.data.title;
      this.subcourse_name = this.data.sub_title;
      this.CourseImg = { url: this.data.cover_img };
      this.Documentfile = { name: this.data.file, url: this.data.file };
      this.description = this.data.description;
      this.level = this.data.level;
      this.value = {
        name: `${this.data.lecturer.first_name} ${this.data.lecturer.last_name}`,
        code: this.data.lecturer.lecturer_id
      };
      this.course_price =
        this.data.course_prices.price > 0
          ? this.data.course_prices.price
          : null;
      if (this.course_price > 0) {
        this.priceType = "paid";
      } else {
        this.priceType = "free";
      }
      this.paymenttype = this.data.course_prices.day_until_expire;
      this.videoinfo = this.data.intro_video;
    },
    CheckCourseName() {
      if (this.course_name) {
        this.errors = [];
        axios.api
          .post(`${baseUrl.baseurl()}/checkCourseUpdateExist`, {
            course_id: this.data.course_id,
            title: this.course_name
          })
          .then(() => {
            this.isDisable = false;
          })
          .catch(err => {
            this.errors.push(err.response.data.error);
            this.isDisable = true;
          });
      }
    },
    CheckCourseCode() {
      if (this.course_code) {
        this.errors = [];
        axios.api
          .post(`${baseUrl.baseurl()}/checkCourseUpdateExist`, {
            course_id: this.data.course_id,
            course_code: this.course_code
          })
          .then(() => {
            this.isDisable = false;
          })
          .catch(err => {
            this.errors.push(err.response.data.error);
            this.isDisable = true;
          });
      }
    }
  },
  async mounted() {
    this.$store.dispatch("general/getAll_Lecturer");
    // this.value = {
    //     name : `${this.data.lecturer.first_name}  ${this.data.lecturer.last_name}`,
    //     code: `${this.data.lecturer.lecturer_id}`
    //   }
    this.Syncdata();
  },

  data() {
    return {
      videoinfo: null,
      description: null,
      CourseImg: null,
      Documentfile: [],
      videofile: [],
      value: null,
      course_price: null,
      priceType: "paid",
      paymenttype: null,
      vidPercent: 0,
      vidLink: "",
      vidList: [],
      errors: [],
      course_name: null,
      subcourse_name: null,
      course_code: null,
      level: null,
      isDisable: false
    };
  },
  computed: {
    ...mapGetters({
      options: "general/choice",
      data: "general/editPage"
    })

    // course_expire() {
    //   return this.data.course_prices.day_until_expire == 30 ?
    //   this.paymenttype = 'รายเดือน' :
    //   this.data.course_prices.day_until_expire == 0 ?
    //   this.paymenttype = 'ถาวร' :
    //   this.paymenttype = null
    // }
  },
  components: {
    Multiselect
  }
};
</script>

<style lang="scss" scoped>
.uploadbanner {
  border: red;
  height: 100px;
}
.fromstyle {
  padding: 0;
}
.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
  &:disabled {
    background-color: gray;
    color: black;
  }
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}
.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
.upload-btn {
  border-radius: 10px;
  border-style: none;
  height: 42.5px;
}
.upload-btn-img {
  height: 42.5px;
}
</style>

<style lang="scss">
.cus-select {
  font-size: 0.9rem !important;
  margin-bottom: 1.25rem !important;
}

.cus-select .multiselect__tags {
  font-size: 0.9rem !important;
  border: 2px solid #0430ad;
  color: rgba(4, 48, 173, 0.5);
}
</style>
